// extracted by mini-css-extract-plugin
module.exports = {"colors":"'../../css/colors.css'","darkOrange":"#D8630F","products":"ProductsPage_products__65fhB"};